import c3 from 'c3';
import 'c3/c3.min.css';
import * as d3 from 'd3';
// import D3Funnel from 'd3-funnel/dist/d3-funnel.js';
import "./styles.css";
import useStyles from "./styles";
import { useSelector } from "react-redux";
import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import GeoChart from '../GeoChart';
import { pathOr } from "ramda";
import { getCalculations } from '../../../../../../common/policyCalculation';
import SkeletonShell from "../../../../../../components/Skeleton/index";


const CustomDashletChart = ({ data, fullData, value, result = [],isDashletUpdated=[],allTabFilter=[],isPdf=false, id }) => {

	const { currentTheme } = useSelector((state) => state.config.themeConfig);
	const [dashId, setDashId] = useState(pathOr('', ['id'], fullData));
	const [showLoading,setShowLoading]= useState(isDashletUpdated.includes(dashId));
	const {  configureDashletLoading } = useSelector(
		(state) => state.dashboard,
	  );
	  
	  const [chartData, setChartData] = useState(pathOr(data, ['charts',0], data));
	
	 

	const makeid=()=> {
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	  
		for (var i = 0; i < 5; i++)
		  text += possible.charAt(Math.floor(Math.random() * possible.length));
	  
		return text;
	  }
	const callbackMethod = pathOr(pathOr('', [ 'callbackMethod'], chartData), ['data', 'callbackMethod'], chartData);
	 
	const classes = useStyles();
	let chartJson = [];
	const min = 1;
    const max = 100;
    const rand = min + Math.random() * (max - min);
	let chartNewName = Math.random();
	const isConsolidated = pathOr(false, ["isConsolidated"], data)
	let chartName =  isConsolidated ? id : pathOr(pathOr('', ['text'], chartData), ['name'], chartData).replace(/\s/g, '_');
	const newColumns = callbackMethod && result? getCalculations(callbackMethod, result) : [];
	const chartType=pathOr(pathOr('', ['type'], chartData), ['chartType'], chartData);
	const chartActualSize=pathOr({}, ['chartActualSize'], chartData);
	// var colors = ["#e196aa", "#fcd385", "#b5cfec", "#9190ab", "#a0beaf","#047281","gray","blue","green"];
	// var comboColors =  newColumns.reduce(function(comboColors, field, index) {
	// 	if(newColumns[index]){comboColors[Object.values(newColumns[index])[0]] = colors[index];}
	// 	return comboColors;
	//   }, {})
	// console.log("chartName=====================>",chartType,result,newColumns,chartData,fullData)
	switch (chartType) {
		case 'pie':
		case 'donut':
			
			chartJson = {
				bindto: '#' + chartName,

				legend: {
					show: true
				},
				size: chartActualSize,
				
				data: {
					columns: newColumns,
					type: chartType,
					// colors: comboColors,
					
					// {
					// 	Equity: 'gray',
					// 	Equities: 'gray',
					// 	Bond: 'blue',
					// 	Balanced: 'green'
					// },
					empty: { label: { text: "No Data" } },
					

				},
				color: {
					pattern: ["#047281", "#e196aa", "#a0beaf", "#fcd385","gray","blue","green"]
				},

				donut: {
					width: isPdf?40:40,
					label: {
						threshold: 0.01,
						// format: function (value, ratio, id) {
						// 	return '';
						// }
					},
				 }
				
			};
			break;

		case 'line_chart':
		case 'line':
		case 'line_chart2':
			chartJson = {
				padding: {
					right: 20,
					bottom: 20,
				},
				bindto: '#' + chartName,
				data: {
					x:'x',
					columns: newColumns,
					type: 'line',
					// colors: comboColors,
					empty: { label: { text: "No Data Available" } },

				},
				color: {
					pattern: ["#047281", "#e196aa", "#a0beaf", "#fcd385", "#a0beaf","#047281","gray","blue","green"]
				},


			};
			break;
		case 'bar':
			chartJson = {
				padding: {
					right: 20,
					bottom: 20,
				},
				bindto: '#' + chartName,
				data: {
					x:'x',
					columns: newColumns,
					type: 'bar',
					// colors: comboColors,
					empty: { label: { text: "No Data Available" } },

				},
				color: {
					pattern: ["#047281", "#e196aa", "#a0beaf", "#fcd385", "#a0beaf","#047281","gray","blue","green"]
				},

				grid: {
					y: {
						lines: [{ value: 0 }]
					}
				},
				bar: {
					width: {
						ratio: 0.08 // this makes bar width 50% of length between ticks
					}
				}, axis: {
					x: {
						
						// extent: [2, 4],
						// type: 'category',
						tick: {
							rotate: 50,
							multiline: false,
						},
						// height: 130
					},
					// y2: {
					// 	show: true,
					// 	tick: {
					// 		format: function (d) {
					// 			return (parseInt(d) == d) ? d.toFixed(2)+'%' : d.toFixed(2)+'%';
					// 		}
					// 	},
					// 	// label: {
					// 	// 	text: 'Year on Year Return',
					// 	// 	position: 'outer-middle'
					// 	// }
					// },
					range: { max: 100, min: -100 },
					y: {
						// label: {
						// 	text: 'Average Annual Return',
						// 	position: 'outer-middle'
						// 	// inner-right : default
						// 	// inner-center
						// 	// inner-left
						// 	// outer-right
						// 	// outer-center
						// 	// outer-left
						// },
						tick: {
							// format: function (d) {
							// 	return (parseInt(d) == d) ? d.toFixed(2) : d.toFixed(2);
							// }
							format: d3.format(",")
						}
					}
				}

			};
			break;
		case 'stacked':

		// console.log("newColumnsnewColumns,stacked",newColumns)
				chartJson = {
					padding: {
						right: 20,
						bottom: 20,
					},
					bindto: '#' + chartName,
					data: {
						// x:'x',
						columns: pathOr([],['data'],newColumns),
						type: 'bar',
						groups: [
							pathOr([],['group'],newColumns)
						],
						labels: {
							format: d3.format('01,d')
						  },
						// colors: comboColors,
						empty: { label: { text: "No Data Available" } }
						
					},
					grid: {
						y: {
							show: true
						}
					},	
					color: {
						pattern: ["#e196aa", "#a0beaf", "#fcd385","#047281", "purple","blue","green"]
					},
					// point: {
					// 	r: 5,
					// },
					// line: {
					// 	thick: 100,
					// },
		
					// grid: {
					// 	y: {
					// 		lines: [{ value: 0 }]
					// 	}
					// },
					// bar: {
					// 	width: {
					// 		ratio: 0.08 // this makes bar width 50% of length between ticks
					// 	}
					// },
					 axis: {
						 
						x: {
							show:false,
							tick: {
								rotate: 50,
								multiline: false,
							},
							// height: 130
						},
						// range: { max: 100, min: -100 },
						y: {
							// max: 100,
							// min: -100,
							// padding: {top: 0, bottom: 0},
							tick: {
								format: d3.format(",")
							}
						}
					}
	
				};
				break;
		
		default:
			chartJson = {};

	}

	React.useEffect(() => {
	
		if (chartType !== 'geo' && newColumns) {

			c3.generate(chartJson);
			}
	}, [chartJson]);
	return (
		<div className={currentTheme === 'dark' ? "inverted" : null}>

			{chartType === 'geo' ?
				(configureDashletLoading && isDashletUpdated.length) || (showLoading) ? <SkeletonShell layout={chartType==='pie'?"chartRound":"chartRectangle"} /> :<GeoChart data={data} value={value} fullData={fullData} />
				: (configureDashletLoading && isDashletUpdated.length) || (showLoading) ? <SkeletonShell layout={chartType==='pie'?"chartRound":"chartRectangle"} /> : <div key={chartName} style={{minHeight:isPdf?pathOr(150, ['chartActualSize', 'height'], chartData):220,height:isPdf?pathOr(150, ['chartActualSize', 'height'], chartData):220,width:isPdf?pathOr(150, ['chartActualSize', 'width'], chartData):'100%'}} className={classes.chartBox} id={chartName}>
					<Typography align="center"><i className={" fas fa-7x fa-exclamation-triangle " + classes.noData}></i></Typography>
					<Typography align="center" color="textSecondary">No Data</Typography>
				</div>}
		</div>
	);

}
export default React.memo(CustomDashletChart);